import ListIcon from '@material-ui/icons/List';
import BudgetList from './BudgetList';
import BudgetCreate from './BudgetCreate';

export default {
    list: BudgetList,
    create: BudgetCreate,
    icon: ListIcon,
};
